import { AlertTriangle, CheckCircle2 } from "lucide-react";

export function ServiceNotice({ data }: { data: any }) {
  if (!data) return null;
  if (!data.in_service_area) {
    return (
      <div role="alert" data-testid="service-unavailable-notice" className="flex gap-3 rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
        <AlertTriangle size={18} className="mt-0.5 shrink-0" />
        <span><strong>FASTPASS transport is not available at this location.</strong> We currently serve Metro Cebu only. For emergencies call <a className="font-bold underline" href={`tel:${data.emergency_hotline}`}>{data.emergency_hotline}</a>.</span>
      </div>
    );
  }
  const real = data.available_responders - data.simulated_responders;
  return (
    <div data-testid="service-available-notice" className="flex gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-900">
      <CheckCircle2 size={18} className="mt-0.5 shrink-0" />
      <span>
        Inside the <strong>{data.area}</strong> service area. Responders currently on duty: <strong data-testid="available-responders-count">{data.available_responders}</strong>
        {data.simulated_responders > 0 && <> ({data.simulated_responders} simulated test unit{data.simulated_responders > 1 ? "s" : ""}, {real} real)</>}.
        {" "}Availability is not a guarantee of response time.
      </span>
    </div>
  );
}
